import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupCarreras } from '../Carreras/LookupCarreras';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

const PRACTICA_OPTIONS = withSelectPlaceholder(
  [
    { value: 'S', label: 'Sí' },
    { value: 'N', label: 'No' },
  ],
  SELECT_LABELS.practica
);

const DICTADO_OPTIONS = withSelectPlaceholder(
  [
    { value: '1', label: 'Primer Cuatrimestre' },
    { value: '2', label: 'Segundo Cuatrimestre' },
    { value: 'A', label: 'Anual' },
  ],
  SELECT_LABELS.cuatrimestre
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatDictadoLabel(dictado) {
  if (dictado === '1') return 'Primer Cuatrimestre';
  if (dictado === '2') return 'Segundo Cuatrimestre';
  return 'Anual';
}

function formatPracticaLabel(practica) {
  if (practica === 'S') return 'Sí';
  if (practica === 'N') return 'No';
  return practica || '—';
}

export class UpdateMateria extends Component {
  static displayName = UpdateMateria.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      code: '',
      name: '',
      anioDictado: '',
      dictado: '',
      practica: '',
      carrera: { carreraCod: 0, carreraNombre: '' },
      showLookupCarreras: false,
      valuePractica: selectPlaceholder(SELECT_LABELS.practica),
      valueDictado: selectPlaceholder(SELECT_LABELS.cuatrimestre),
      errorMessage: '',
      redirect: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  async componentDidMount() {
    if (constantClass.canAccess('WWMaterias')) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleFieldChange = (field) => (e) => {
    this.clearFeedback();
    this.setState({ [field]: e.target.value });
  };

  handlePracticaChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valuePractica: option, practica: value });
  };

  handleDictadoChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valueDictado: option, dictado: value });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupCarreras: false,
      carrera: {
        carreraCod: parseInt(carreraProperties[0], 10),
        carreraNombre: carreraProperties[1],
      },
    });
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookupCarreras: true });
    }
  };

  handleHideCarreraLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  isFormValid() {
    return (
      this.state.code.trim().length > 0
      && this.state.name.trim().length > 0
      && this.state.anioDictado.trim().length > 0
      && this.state.dictado.length > 0
      && this.state.practica.length > 0
      && this.state.carrera.carreraNombre.trim().length > 0
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveMateria();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/mxc/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(data, 'No se pudieron cargar los datos de la materia.'),
      });
      return;
    }

    const model = data.returnModel;
    const practica = (model.materiaPractica || 'N').toString().trim();
    const dictado = (model.materiaCarreraDictado || '').toString().trim();
    const selectedPractica =
      PRACTICA_OPTIONS.find((x) => x.value === practica) ||
      PRACTICA_OPTIONS.find((x) => x.value === 'N');
    const selectedDictado =
      DICTADO_OPTIONS.find((x) => x.value === dictado) ||
      DICTADO_OPTIONS.find((x) => x.value === 'A');

    this.setState({
      loadingInitial: false,
      carrera: {
        carreraCod: model.carreraCod,
        carreraNombre: model.carreraNombre.trim(),
      },
      code: model.materiaCarreraCodigo,
      name: model.materiaCarreraNombre.trim(),
      anioDictado: model.materiaCarreraAnio.trim(),
      dictado,
      practica,
      valuePractica: selectedPractica,
      valueDictado: selectedDictado,
    });
  }

  async saveMateria() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/Materia', {
      method: 'POST',
      body: JSON.stringify({
        MateriaCarreraCod: this.state.id,
        MateriaCarreraNombre: this.state.name,
        MateriaCarreraDictado: this.state.dictado,
        MateriaCarreraAnio: this.state.anioDictado,
        MateriaPractica: this.state.practica,
        CarreraCod: this.state.carrera.carreraCod,
        MateriaCarreraCodigo: this.state.code,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la materia. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-mxc" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      code,
      name,
      anioDictado,
      dictado,
      practica,
      carrera,
      showLookupCarreras,
      valuePractica,
      valueDictado,
      errorMessage,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly ? 'Detalle de Materia' : 'Modificar Materia';

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-mxc">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-mxc">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-mxc">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la materia.'
            : 'Actualice los datos de la materia y confirme los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando cambios, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="materia-codigo">
                Código Materia
              </label>
              <input
                id="materia-codigo"
                className="md-form-page__input"
                type="text"
                value={code}
                onChange={this.handleFieldChange('code')}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="materia-nombre">
                Nombre Materia
              </label>
              <input
                id="materia-nombre"
                className="md-form-page__input"
                type="text"
                value={name}
                onChange={this.handleFieldChange('name')}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="materia-anio">
                Año Dictado
              </label>
              <input
                id="materia-anio"
                className="md-form-page__input"
                type="text"
                value={anioDictado}
                onChange={this.handleFieldChange('anioDictado')}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Dictado</span>
              {this.isReadOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={formatDictadoLabel(dictado)}
                  disabled
                  readOnly
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="materia-dictado"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valueDictado}
                    options={DICTADO_OPTIONS}
                    onChange={this.handleDictadoChange}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carrera</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCarreraLookup}
                  disabled={isBusy}
                >
                  Seleccione la Carrera
                </button>
              ) : null}
              {showLookupCarreras ? (
                <LookupCarreras
                  selectItem={this.handleSelectCarreraItem}
                  hideLookup={this.handleHideCarreraLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={carrera.carreraNombre}
                disabled
                readOnly
                aria-label="Carrera"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia Práctica</span>
              {this.isReadOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={formatPracticaLabel(practica)}
                  disabled
                  readOnly
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="materia-practica"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valuePractica}
                    options={PRACTICA_OPTIONS}
                    onChange={this.handlePracticaChange}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
